<template lang="pug">
  app-card.knowbase

    template(v-if="rootCategory && rootCategory.alias == 'common'")
        app-card-header.knowbase__header
          span(v-if="this.doc.knowledgeCategory") {{ doc.knowledgeCategory.title }}
          v-spacer
          span.mr-4 {{ oDate }}
          | 
        app-card-body.knowbase__body
          app-card-caption.knowbase__caption(v-html="searchItem(doc.number)")
          app-card-title.knowbase__title(v-html="searchItem(doc.clause)")
          
          
          div.knowbase__content
            div Автор: 
              span(v-html="searchItem(doc.judgeName)")
            div Вид документа: 
              span(v-html="searchItem(doc.decree)")
            div.knowbase__note(v-if="doc.note && doc.note !=''" v-html="searchItem(doc.note)")
              

    template(v-else)
      app-card-header.knowbase__header
        span.mr-10(v-if="this.doc.knowledgeCategory") {{ doc.knowledgeCategory.title }}
        span.ml-10 Год: {{ doc.year }}
        v-spacer
        span.mr-4 {{ oDate }}
        | 
      app-card-body.knowbase__body
        app-card-caption.knowbase__caption(v-html="searchItem(doc.number)")
        app-card-title.knowbase__title(v-html="searchItem(doc.clause)")

        div.knowbase__content
          v-row
            .col-9
              div Судья:
                span(v-html="searchItem(doc.judgeName)")
              div Стороны: 
                span(v-html="searchItem(doc.sides)")
              div Состав коллегии: 
                span(v-html="searchItem(doc.colleg)")
              div(v-if="doc.type") Тип делопроизводства: {{ doc.type.title }}
            .col-3
              div.knowbase__decree(v-if="doc.decreeState")
                div Принятое решение:
                  span(v-html="searchItem(doc.decree)")
                div(v-if="doc.decreeState") Решение: 
                  span(:class="'decree-color-'+doc.decreeState.value") {{ doc.decreeState.title }}
      
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
moment.locale('ru')
export default {
  name: 'knowledgebase-list',
  props: {
    doc: {
      type: Object,
      required: true
    },
    search: String
  },

  computed: {
    ...mapState('knowledgeBase', ['knowledgeCategory']),
    oDate(){
      return moment(this.doc.date).format('DD.MM.YYYY');
    },

    rootCategory(){
      if (this.doc.knowledgeCategory) return this.findRootCatSelected(this.doc.knowledgeCategory)
      return null
    },
  },

  methods: {
    searchItem (text) {
      if (!text || text === undefined) return text
      if (!this.search || this.search.length == 0) {
        return text
      }
      return text.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    findRootCatSelected(item){
      return this.findRootCatSelectedRec(this.knowledgeCategory,item)
    },

    findRootCatSelectedRec(arr,item){
      let rootCat = arr.filter(i => {return i.id == item.id})[0]
      if (!rootCat){
        for (let itm of arr) {
          let cc = this.findRootCatSelectedRec(itm.children,item)
          if (cc) {
            rootCat = itm
            break
          }
        }
      }
      return rootCat
    }
  }
}
</script>

<style lang="scss" scoped>
  .knowbase {
    &__header {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
    }

    &__body {
      
    }

    &__title {
      font-family: Roboto Condensed;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 16px;
      color: #314369;
      margin-bottom:15px;
    }

    &__caption {
      font-family: Roboto Slab;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      color: #757575;
      margin-bottom:8px;
    }

    &__content {
      font-family: Roboto Condensed;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #757575;
    }

    &__decree {
      border-left:1px solid #000;
      padding:5px;
      font-family: Roboto Condensed;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #757575;
    }

    &__note {
      border-left:1px solid #000;
      padding:5px;
      margin-top:15px;
      font-family: Roboto Condensed;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #757575;
    }
  }
  .decree-color-0 {color:#00ff00;}
  .decree-color-1 {color:#ff0000;}
  .decree-color-2 {color:#f39c12;}
</style>